/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $BiometricsResultStatus = {
  type: 'Enum',
} as const;
